import Cookies from 'js-cookie'
import {ajax} from '@/libs/ajax'
import global from '@/libs/global'

const user = {
  namespaced: true,
  state: {
    user: {},
    cityCode: '', // 门店区域编码
    authoritieMap: new Map()
  },
  getters: {
    authorities (state, getters) {
      return state.user.authorities || []
    },
    /**
     * 判断是否有权限
     * @param state vuex state
     * @param authority 权限
     * @returns {boolean} 是否有权限
     */
    has: (state, getters) => (authority) => {
      if (authority === undefined) {
        return true
      }

      if (state.authoritieMap.has(authority)) {
        return state.authoritieMap.get(authority)
      }

      return getters.authorities.some(a => {
        const value = authority === a
        if (value) {
          state.authoritieMap.set(a, true)
        }
        return value
      })
    }
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    SET_CITYCODE (state, cityCode) {
      state.cityCode = cityCode
    },
    logout (state, vm) {
      // state.user = {}
      // state.authoritieMap = new Map()
      ajax.post('/auth/logout', {token: state.user.access_token}).then(response => {
        const result = response.data
        if (global.checkGetwayCode(result.code)) {
          Cookies.remove('account')
          // Cookies.remove('password')
          state.user = {}
          localStorage.clear()
        }
      })
    }
  },
  actions: {
    setCityCode ({commit}, citycode) {
      commit('SET_CITYCODE', citycode)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js